import { Component, computed, effect, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConnectivityService } from '@/offline/connectivity.service';
import { DocumentDeviceMonitorService } from '@/offline/document-device-monitor.service';

@Component({
    selector: 'app-document-device-alert',
    imports: [RouterModule],
    templateUrl: './document-device-alert.component.html',
})
export class DocumentDeviceAlertComponent {

    private connectivity = inject(ConnectivityService);
    private monitor = inject(DocumentDeviceMonitorService);

    dismissed = signal(false);

    /** Only warn while we're currently online - no point alerting someone who's already offline that they might lose connection. Re-evaluates on every hourly tick (`lastCheckedAt`) too, not just when a new heartbeat arrives, so a device that's gone silent surfaces the alert even with no fresh websocket data. */
    showAlert = computed(() => {
        if (!this.connectivity.backendOnline()) return false;
        this.monitor.lastCheckedAt();
        return this.monitor.isStale(this.monitor.status());
    });

    message = computed(() => {
        const s = this.monitor.status();
        if (!s) {
            return 'No se ha detectado ningún ordenador designado para generar documentos si se pierde la conexión a internet.';
        }
        return `El ordenador designado ("${s.name}") lleva tiempo sin dar señal: si se pierde la conexión a internet, no habrá ningún ordenador disponible para generar documentos.`;
    });

    constructor() {
        // A fresh bad state (or a fresh check finding it's still bad) always re-surfaces, even if previously dismissed.
        effect(() => {
            this.showAlert();
            this.dismissed.set(false);
        });
    }

    dismiss(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.dismissed.set(true);
    }
}
